import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { envConfig } from "../../config";
import Emitter from "./EventEmitter";
import { WebsocketEventMapping } from "./events";
export const WebsocketConnection = ({ children, token, onClose }) => {
    const [socketUrl, setSocketUrl] = useState(`${envConfig.websocket.url}?token=${token}`);
    const { lastMessage, readyState, getWebSocket } = useWebSocket(socketUrl, {
        onClose,
    });
    useEffect(() => {
        setSocketUrl(`${envConfig.websocket.url}?token=${token}`);
    }, [token]);
    const connection = getWebSocket();
    useEffect(() => {
        console.log(connection);
        return () => {
            connection === null || connection === void 0 ? void 0 : connection.close();
        };
    }, [connection]);
    const handleMessage = (message) => {
        const msgObj = JSON.parse(message);
        if (WebsocketEventMapping[msgObj.type]) {
            Emitter.emit(WebsocketEventMapping[msgObj.type], {
                type: WebsocketEventMapping[msgObj.type],
                payload: message,
            });
            return;
        }
        console.error("Message type not supported", { message });
    };
    useEffect(() => {
        console.log("MESSAGE: ", lastMessage);
        if (lastMessage !== null) {
            handleMessage(lastMessage.data);
        }
    }, [lastMessage]);
    const connectionStatus = {
        [ReadyState.CONNECTING]: "Connecting",
        [ReadyState.OPEN]: "Open",
        [ReadyState.CLOSING]: "Closing",
        [ReadyState.CLOSED]: "Closed",
        [ReadyState.UNINSTANTIATED]: "Uninstantiated",
    }[readyState];
    console.log("Connection Status: ", connectionStatus);
    return _jsx(_Fragment, { children: children });
};
